import React, { useState } from 'react';
import './game-settings.css';
import { connect } from 'react-redux';

import { IconButton } from '../../components/icon-button';
import { Panel } from '../../components/panel';
import { Heading } from '../../components/heading';
import { TextButton } from '../../components/text-button';
import { Paragraph } from '../../components/paragraph';
import { IssueChoice } from './issue-choice';
import { RadioButtonGroup } from '../../components/radio-button-group';

import { SETTINGS_SCREEN, WELCOME_LETTER_SCREEN } from '../../constants/routes';
import { goBack, goToScreen } from '../../actions/router';
import { setGameSettings } from '../../actions/settings';
import {
    setCalendar,
    setMeetingsIndexes,
    setMessagesIndexes,
} from '../../actions/active-game';
import { getCalendar } from '../../helpers/story-mode';
import { getMessagesOrMeetings } from '../../helpers/active-game';
import { returnPartyString } from '../../helpers/active-game';
import Copy from '../../copy/game-settings';

const GameSettingsScreen = props => {
    const { goBack, goToSettings, setSettingsAndContinueToGame } = props;

    const [step, setStep] = useState(0);

    const [activeDifficulty, setActiveDifficulty] = useState(null);
    const [activeParty, setActiveParty] = useState(null);
    const [activeIssue, setActiveIssue] = useState(null);

    const startGame = () => {
        setSettingsAndContinueToGame(
            activeDifficulty,
            activeParty,
            activeIssue,
        );
    };

    const onClick =
        step === 0
            ? () => setStep(1)
            : step === 1
            ? () => setStep(2)
            : () => startGame();

    const onBack =
        step === 0
            ? () => goBack()
            : step === 1
            ? () => setStep(0)
            : () => setStep(1);

    const buttonDisabled =
        step === 0
            ? activeDifficulty === null
            : step === 1
            ? activeParty === null
            : step === 2
            ? activeIssue === null
            : false;

    return (
        <div className="game-settings">
            <IconButton
                iconName="back"
                type="essential"
                size="small"
                onClick={onBack}
                withSpacing={true}
            />
            <Panel
                flexDirection="column"
                color="purple"
                currentPage={`game-settings step ${step + 1}`}
                key={step}
            >
                <div className="game-settings__content">
                    <div className="game-settings__header">
                        <Heading
                            headingType="h3"
                            size="large"
                            colorScheme="dark"
                            align="center"
                            withSpacing={false}
                        >
                            {Copy['start-game-settings'].headings[step]}
                        </Heading>
                        <Paragraph colorScheme="dark" withSpacing={false}>
                            {step + 1} of 3
                        </Paragraph>
                    </div>
                    {(() => {
                        switch (step) {
                            case 0:
                                return (
                                    <RadioButtonGroup
                                        key="difficulty"
                                        group={
                                            Copy['start-game-settings']
                                                .headings[0]
                                        }
                                        options={[
                                            { label: 'Easy' },
                                            { label: 'Medium' },
                                            { label: 'Hard' },
                                        ]}
                                        checked={activeDifficulty}
                                        onChange={e =>
                                            setActiveDifficulty(e.target.value)
                                        }
                                    />
                                );
                            case 1:
                                return (
                                    <RadioButtonGroup
                                        key="party"
                                        group={
                                            Copy['start-game-settings']
                                                .headings[1]
                                        }
                                        checked={activeParty}
                                        options={[
                                            { label: 'Governing Party' },
                                            { label: 'Opposing Party' },
                                        ]}
                                        onChange={e =>
                                            setActiveParty(e.target.value)
                                        }
                                    />
                                );
                            case 2:
                                return (
                                    <IssueChoice
                                        activeIssue={activeIssue}
                                        setActiveIssue={setActiveIssue}
                                    />
                                );
                            default:
                                return <Panel />;
                        }
                    })()}
                    <div>
                        <TextButton
                            key={'button' + step}
                            text="Continue"
                            onClick={onClick}
                            isDisabled={buttonDisabled}
                        />
                    </div>
                </div>
            </Panel>

            <IconButton
                iconName="settings"
                type="essential"
                size="small"
                onClick={goToSettings}
                withSpacing={true}
            />
        </div>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        goBack: () => {
            dispatch(goBack());
        },
        goToSettings: () => {
            dispatch(goToScreen(SETTINGS_SCREEN));
        },
        setSettingsAndContinueToGame: (difficulty, party, importantIssue) => {
            const partyString = returnPartyString(party);
            const difficultyString = difficulty.toLowerCase();
            dispatch(
                setGameSettings(difficultyString, partyString, importantIssue),
            );
            dispatch(goToScreen(WELCOME_LETTER_SCREEN));
            dispatch(setCalendar(getCalendar(partyString, difficultyString)));
            dispatch(
                setMessagesIndexes(
                    getMessagesOrMeetings(
                        partyString,
                        difficultyString,
                        'messages',
                    ),
                ),
            );
            dispatch(
                setMeetingsIndexes(
                    getMessagesOrMeetings(
                        partyString,
                        difficultyString,
                        'meetings',
                    ),
                ),
            );
        },
    };
};

const connected = connect(null, mapDispatchToProps)(GameSettingsScreen);
export { connected as GameSettingsScreen };
